/**
 * Health API module
 */
import { coreClient, apiRequest } from '../client.js';
import type { CoreSystemHealth, CoreSystemMetrics, IncidentsResponse, ProviderUsageData } from '../types.js';

export const healthApi = {
  check: () =>
    apiRequest<CoreSystemHealth>(coreClient, {
      method: 'GET',
      url: '/health',
    }),
  
  metrics: () =>
    apiRequest<CoreSystemMetrics>(coreClient, {
      method: 'GET',
      url: '/health/metrics',
    }),
  
  incidents: () =>
    apiRequest<IncidentsResponse>(coreClient, {
      method: 'GET',
      url: '/health/incidents',
    }),
  
  createIncident: (incident: {
    title: string;
    severity: 'low' | 'medium' | 'high' | 'critical';
    description: string;
    affectedServices: string[];
  }) =>
    apiRequest<Record<string, unknown>>(coreClient, {
      method: 'POST',
      url: '/health/incidents',
      data: incident,
    }),
  
  resolveIncident: (incidentId: string) =>
    apiRequest<Record<string, unknown>>(coreClient, {
      method: 'PATCH',
      url: `/health/incidents/${incidentId}/resolve`,
    }),
  
  getProviderUsage: () =>
    apiRequest<ProviderUsageData>(coreClient, {
      method: 'GET',
      url: '/health/providers/usage',
    }),
};

export default healthApi;
